import React, { Component } from 'react'
import { withStyles, Drawer, Typography, Divider, TextField, Button, AppBar, Toolbar, IconButton, FormControl, InputLabel, Select, MenuItem, Grid, OutlinedInput } from '@material-ui/core';

const drawerWidth = 500;

const styles = theme => ({
    root: {
        width: drawerWidth,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '100%'
    },
    textStyle: {
        fontWeight: 400
    },
    paddingForm: {
        padding: '20px'
    },
    footerButton: {
        padding: theme.spacing.unit
    },
    formControl: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '100%'
    }
})

class CourseAdd extends Component {
    constructor(props) {
        super(props);

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!

        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        var today = yyyy + '-' + mm + '-' + dd;
        

        this.state = {
            id: '',
            today: today,
            account_type: this.props.type,
            account_id: '',
            entry_date: today,
            amount: '',
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);

    }

    __getInitialState = () => {

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!

        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        var today = yyyy + '-' + mm + '-' + dd;


        this.setState({
            id: '',
            today: today,
            account_type: this.props.type,
            account_id: '',
            entry_date: today,
            amount: '',
        })
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    componentDidMount() {
        if (this.props.edit) {
            this.setState({
                ...this.props.edit_data,
                amount: this.props.edit_data.cr_bal
            })
        } else {
            this.__getInitialState();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            if (this.props.edit) {
                this.setState({
                    ...this.props.edit_data,
                    amount: this.props.edit_data.cr_bal
                })
            } else {
                this.__getInitialState();
            }
        }
    }


    onSubmit(e) {
        e.preventDefault();

        const data = this.state;


        if (this.props.edit) {
            this.props.esetData(data);

        } else {
            this.props.setData(data);

        }

        this.__getInitialState();

    }

    onDeleteClick(id) {
        this.props.onDeleteClick(id);
    }

    render() {
        let { classes } = this.props;
        let i = [];
        if(this.props.type === 'head'){
            let op_head = this.props.op_head;
            if(Array.isArray(op_head) && op_head.length > 0){
                i = op_head.map((el,index) => 
                    <MenuItem key={index} value={el.id}>{el.head_name}</MenuItem>
                )
            }
        } else if (this.props.type === 'account'){
            let op_head = this.props.op_account;
            if (Array.isArray(op_head) && op_head.length > 0) {
                i = op_head.map((el, index) =>
                    <MenuItem key={index} value={el.id}>{el.bank_name}</MenuItem>
                )
            }
        }
        return (
            <div>
                <Drawer
                    className={classes.root}
                    anchor="right"
                    open={this.props.show}
                    onClose={this.props.handleClose}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >

                    <AppBar position="static" color={this.props.edit ? "secondary" : "primary"} >
                        <Toolbar>
                            <Typography variant="h6" color="inherit" >
                                {this.props.edit ? "Edit DATA" : "Add New"}
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    <div className={classes.paddingForm}>

                        <form onSubmit={this.onSubmit}>


                            <FormControl required variant="outlined" className={classes.formControl}>
                                <InputLabel>Payement Head</InputLabel>
                                <Select
                                    name="account_id"
                                    value={this.state.account_id}
                                    onChange={this.onChange}
                                    input={
                                        <OutlinedInput
                                            labelWidth={200}
                                            name="account_id"
                                        />
                                    }

                                >
                                    <MenuItem>
                                        <em>None</em>
                                    </MenuItem>
                                    {i}
                                </Select>
                            </FormControl>


                            <br />
                            


                            <TextField
                                variant="outlined"
                                label="Date"
                                name="entry_date"
                                className={classes.textField}
                                type="date"
                                
                                margin="normal"
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    },
                                    shrink: true,
                                    
                                }}
                                value={this.state.entry_date}
                                onChange={this.onChange}
                                
                            />


                            <TextField
                                variant="outlined"
                                label="Amount"
                                name="amount"
                                className={classes.textField}
                                type="text"
                                margin="normal"
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.amount}
                                onChange={this.onChange}

                            />



                            <div className={classes.footerButton}>

                                <Button
                                    type="submit"
                                    variant="outlined"
                                    color={this.props.edit ? "secondary" : "primary"}
                                    className={classes.button}>
                                    {this.props.edit ? "Update" : "Submit"}
                                </Button>

                                {this.props.edit ?
                                    <span>&nbsp;
                                    <Button
                                            type="button"
                                            variant="outlined"
                                            color="secondary"
                                            className={classes.button}
                                            onClick={this.onDeleteClick.bind(this, this.props.edit_data.id)}
                                        >
                                            Delete
                                    </Button>
                                    </span>

                                    : null}
                            </div>
                        </form>

                    </div>



                </Drawer>
            </div>
        )
    }
}

export default withStyles(styles)(CourseAdd)